// Mock data for Highland Homes — replace with backend later

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_20fdce66-d5f2-4656-ba0b-01b05150b35d/artifacts/sxj5h6zr_1000005002.jpeg",
  hero: "https://customer-assets.emergentagent.com/job_highland-homes-build/artifacts/w7la53fk_IMG_3906.jpeg",
  barndoDusk: "https://customer-assets.emergentagent.com/job_highland-homes-build/artifacts/llre32cr_IMG_3804.jpeg",
  farmhouse2: "https://customer-assets.emergentagent.com/job_highland-homes-build/artifacts/625hvfq5_IMG_3894.jpeg",
  farmhouseAerial: "https://customer-assets.emergentagent.com/job_highland-homes-build/artifacts/e3pxcldt_IMG_3895.jpeg",
  kitchenBathCollage: "https://customer-assets.emergentagent.com/job_highland-homes-build/artifacts/g2q6cmll_IMG_3902.jpeg",
  kitchen: "https://images.unsplash.com/photo-1758448755927-e5c5ae14790c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBraXRjaGVuJTIwaXNsYW5kfGVufDB8fHx8MTc4MjE2MDI0OXww&ixlib=rb-4.1.0&q=85",
  bath1: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxzcGElMjBiYXRocm9vbSUyMHR1YnxlbnwwfHx8fDE3ODIxNjAyNDl8MA&ixlib=rb-4.1.0&q=85",
  bath2: "https://images.unsplash.com/photo-1533093818119-ac1fa47a6d59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzcGElMjBiYXRocm9vbSUyMHR1YnxlbnwwfHx8fDE3ODIxNjAyNDl8MA&ixlib=rb-4.1.0&q=85",
  blueprint: "https://images.pexels.com/photos/6615086/pexels-photo-6615086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  // Real Highland Homes project photos (re-encoded & served locally for reliability)\n  realMetalBuilding: "/projects/red-metal-building.jpg",
  realHomeConstruction: "/projects/home-construction.jpg",
  realFraming: "/projects/framing.jpg",
  realTileShower: "/projects/tile-shower.jpg",
  realApartment: "/projects/proj-apartment.jpg",
  realSteelFrameA: "/projects/proj-steelframe-a.jpg",
  realSteelFrameB: "/projects/proj-steelframe-b.jpg",
  realFarmhouse2: "/projects/proj-farmhouse.jpg",
  realMetalDoors: "/projects/proj-metalbuilding.jpg",
  redMetalFinished: "/projects/newproj-1.jpg",
  grayBarndo: "/projects/newproj-2.jpg",
  commercialSteel: "/projects/newproj-3.jpg",
  greenPavilion: "/projects/newproj-4.jpg",
  greenPavilionAerial: "/projects/newproj-5.jpg",
  steelAerial1: "/projects/steel-aerial-1.jpg",
  steelAerial2: "/projects/steel-aerial-2.jpg",
  steelAerial3: "/projects/steel-aerial-3.jpg",
  steelAerial4: "/projects/steel-aerial-4.jpg",
  steelAerial5: "/projects/steel-aerial-5.jpg",
  addition1: "/projects/addition-1.jpg",
  addition2: "/projects/addition-2.jpg",
  addition3: "/projects/addition-3.jpg",
  realKitchen: "/projects/kitchen-real-v2.jpg",
  newHomeBuild: "/projects/newhome-build.jpg",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Our Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Our Process", href: "#process" },
  { label: "Contact Us", href: "#contact" },
  { label: "Rejuvenation Coatings", href: "https://www.savagerejuvenationcoatings.com", external: true },
  { label: "Savage HVAC", href: "https://savagehvacfl.com", external: true },
];

export const HERO = {
  tagline: "Crafting Spaces, Building Legacies",
  title: "Welcome to Your Future Home",
  description:
    "At Highland Homes, we do more than construct buildings. We build the backdrop for your life's best moments. From foundation to final polish, our craftsmanship stands the test of time.",
  pillars: ["Bold Designs", "Premium Materials", "Exceptional Craftsmanship"],
};

export const SERVICES = [
  {
    id: "new-home-builds",
    number: "01",
    title: "New Home Builds",
    image: "newHomeBuild",
    points: [
      { h: "Tailored Layouts", t: "We build custom single and two-story properties fitted to your lifestyle." },
      { h: "Full Personalization", t: "Pick every element from flooring to roof color." },
      { h: "Premium Features", t: "Every layout optimizes natural light and open-concept flow." },
    ],
  },
  {
    id: "metal-home-builds",
    number: "02",
    title: "Metal Home Builds (Barndominiums)",
    image: "steelAerial1",
    points: [
      { h: "Ultimate Durability", t: "Highly resistant to extreme weather, fire, and pests." },
      { h: "Industrial Charm", t: "Enjoy vaulted ceilings and massive open floor plans." },
      { h: "Cost-Efficient", t: "Faster construction times compared to traditional wood framing." },
    ],
  },
  {
    id: "home-additions",
    number: "03",
    title: "Home Additions",
    image: "addition1",
    points: [
      { h: "Seamless Integration", t: "We match your existing architecture perfectly." },
      { h: "More Space", t: "Build new primary suites, sunrooms, or multi-generational wings." },
      { h: "Value Boost", t: "Expand your square footage to maximize property resale value." },
    ],
  },
  {
    id: "kitchen-remodels",
    number: "04",
    title: "Kitchen Remodels",
    image: "realKitchen",
    points: [
      { h: "Chef's Paradise", t: "Custom layouts designed around your specific cooking style." },
      { h: "Premium Materials", t: "Quartz countertops, custom cabinetry, and smart appliances." },
      { h: "Social Hubs", t: "Large functional islands built for hosting and family gatherings." },
    ],
  },
  {
    id: "bathroom-remodels",
    number: "05",
    title: "Bathroom Remodels",
    image: "realTileShower",
    points: [
      { h: "Spa-like Retreats", t: "Walk-in tile showers, freestanding tubs, and heated floors." },
      { h: "Smart Storage", t: "Custom vanities that keep clutter hidden away." },
      { h: "Modern Fixtures", t: "Water-efficient, high-end plumbing hardware." },
    ],
  },
];

export const PROCESS = [
  { step: "1", title: "Initial Consultation", desc: "Discuss your budget, project scope, and design ideas." },
  { step: "2", title: "Design & Selections", desc: "Finalize your blueprints and choose materials." },
  { step: "3", title: "Permits & Prep", desc: "We handle all local zoning regulations and site prep work." },
  { step: "4", title: "The Build", desc: "Track progress step-by-step through our customer updates." },
  { step: "5", title: "Final Walkthrough", desc: "Step into your completed, move-in-ready masterpiece." },
];

export const GALLERY = [
  { id: 1, title: "Aerial Steel Frame Build", category: "Metal Home Builds", image: "steelAerial1" },
  { id: 2, title: "Gray Modern Barndominium", category: "Metal Home Builds", image: "grayBarndo" },
  { id: 3, title: "Red Steel Workshop", category: "Metal Home Builds", image: "redMetalFinished" },
  { id: 4, title: "Travertine Tile Shower", category: "Bathroom Remodels", image: "realTileShower" },
  { id: 5, title: "Steel Frame From Above", category: "Metal Home Builds", image: "steelAerial2" },
  { id: 6, title: "Hip-Roof Steel Structure", category: "Metal Home Builds", image: "steelAerial4" },
  { id: 7, title: "Steel Framing Drone View", category: "Metal Home Builds", image: "steelAerial5" },
  { id: 8, title: "Two-Story Farmhouse Build", category: "New Home Builds", image: "realFarmhouse2" },
  { id: 9, title: "Steel Frame Construction", category: "Metal Home Builds", image: "realSteelFrameA" },
  { id: 10, title: "Commercial Steel Building", category: "Metal Home Builds", image: "commercialSteel" },
  { id: 11, title: "Green Steel Pavilion", category: "Metal Home Builds", image: "greenPavilion" },
  { id: 12, title: "Pavilion Aerial View", category: "Metal Home Builds", image: "greenPavilionAerial" },
  { id: 13, title: "Commercial Metal Building", category: "Metal Home Builds", image: "realMetalDoors" },
  { id: 13, title: "Second-Story Addition", category: "Home Additions", image: "addition1" },
  { id: 14, title: "Addition Framing", category: "Home Additions", image: "addition2" },
  { id: 15, title: "Custom Home In Progress", category: "New Home Builds", image: "realHomeConstruction" },
  { id: 16, title: "Butcher-Block Kitchen", category: "Kitchen Remodels", image: "realKitchen" },
  { id: 17, title: "Spa Bathroom Retreat", category: "Bathroom Remodels", image: "bath1" },
];

export const REVIEWS = [
  {
    name: "Sarah & Mark Thompson",
    project: "Custom New Home Build",
    rating: 5,
    text: "Highland Homes turned our vision into reality. The craftsmanship is impeccable and the communication throughout the build was outstanding. We couldn't be happier with our forever home.",
  },
  {
    name: "James Caldwell",
    project: "Barndominium Build",
    rating: 5,
    text: "From the open floor plan to the vaulted ceilings, every detail exceeded expectations. They delivered on time and on budget. Truly exceptional builders.",
  },
  {
    name: "Emily Rodriguez",
    project: "Kitchen & Bath Remodel",
    rating: 5,
    text: "Our kitchen and bathroom feel like a luxury resort now. The team listened to every request and the quartz finishes are stunning. Highly recommend Highland Homes!",
  },
];

export const CONTACT = {
  email: "ian.highlandhomes@gmail.com",
  phone: "(407) 253-6611",
  phone2: "(407) 255-4553",
  location: "Serving your local community",
};
